export type DefaultMutationOptions = (defaultFunc: Promise<void>) => Promise<void>;

export const defaultApiMutationOptions: DefaultMutationOptions = (defaultFunc) =>
  defaultFunc;
